export enum DeprecatedMood {
  Saddest = 1,
  Sadder = 2,
  Sad = 3,
  Neutral = 4,
  Happy = 5,
  Happier = 6,
  Happiest = 7,
}
